import React from 'react';
import PropTypes from 'prop-types';
import FacetSection from '../FacetSection';

const SearchFacets = ({ facets, fieldConfig, searchParameters, onChange }) => {
  return (
    <>
      {fieldConfig.map((s,i) => <FacetSection searchParameters={searchParameters} onChange={onChange} facets={facets} key={i} section={s}/>)}
    </>
  );
};

export { SearchFacets };
SearchFacets.propTypes={
  onChange:PropTypes.func.isRequired,
  searchParameters: PropTypes.shape({}).isRequired,
  facets: PropTypes.shape({}).isRequired,
  fieldConfig:PropTypes.arrayOf(PropTypes.shape({
    'details_open': PropTypes.bool,
    'details_show': PropTypes.bool,
    'icon': PropTypes.node,
    'name': PropTypes.node.isRequired,
    'search_open': PropTypes.bool,
    'search_show': PropTypes.bool,
    'values': PropTypes.arrayOf(PropTypes.shape({
      'category': PropTypes.node,
      'details_show': PropTypes.bool,
      'name': PropTypes.node,
      'reverse': PropTypes.bool,
      'search_show': PropTypes.bool,
      'slug': PropTypes.string.isRequired,
      'type': PropTypes.string.isRequired
    }))
  }))
};

export default SearchFacets;
